import { IdentityHostname } from './identity';
import type { Environment } from './interface';

export const devel5: Environment = {
  apiBusinessGqlUrl: 'https://devel-business-center5.pipelinersales.com/api/business/graphql',
  apiCustomerGqlOrigin: `https://devel-customer-portal5.${IdentityHostname}`,
  apiUserGqlUrl: `https://devel-api5.${IdentityHostname}/api/user/graphql`,
  apiSchedulerGqlUrl: 'https://devel-api5.pipelinersales.com/api/scheduler/public/graphql',
  apiOnlineFormGqlUrl: 'https://devel-api5.pipelinersales.com/api/online-form/public/graphql',
  apiPublicGqlUrl: 'https://devel-api5.pipelinersales.com/api/public/graphql',
  businessCenterUrl: 'https://devel-business-center5.pipelinersales.com',
  customerPortalUrl: 'https://devel-customer-portal5.pipelinersales.com',
  partnerPortalUrl: 'https://devel-partner-portal5.pipelinersales.com',
  crmUrl: `https://devel-crm5.${IdentityHostname}`,
  schedulerUrl: `https://devel-scheduler5.pipelinersales.com`,
  signUpUrl: 'https://staging-wordpress.pipelinersales.com/crm/free-trial/',
  ssoUrl: 'https://devel-accounts5.pipelinersales.com',
  formsUrl: `https://devel-forms5.pipelinersales.com`
};
